import React, { useEffect, useState } from "react";
import { LoginHeader } from "../components/LoginHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock, faBuilding } from "@fortawesome/free-solid-svg-icons";
import stellantis from "../assets/images/Stellantis.png";
import kuantum from "../assets/images/kuantum.png";
import LanguagePicker from "../components/LanguagePicker";
import { useNavigate } from "react-router-dom";
import ReportService from "../services/RaportService";
import { ToastContainer, toast } from "react-toastify";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    console.log("first", isLoggedIn);
    if (isLoggedIn) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    if (e) e.preventDefault();

    console.log("denememeee");

    setLoading(true);

    const reportService = new ReportService();

    try {
      const response = await reportService.login(username, password);
      if (response.data.STATUS === 200) {
        const storage = rememberMe ? localStorage : sessionStorage;
        storage.setItem("userData", JSON.stringify(response.data));
        storage.setItem("isLoggedIn", "true");
        navigate("/dashboard");
      } else {
        toast.error("Giriş başarısız!", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Giriş başarısız:", error);
      toast.error("Kullanıcı adı veya şifre hatalı!", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin(e);
    }
  };

  return (
    <div
      style={{
        background: "linear-gradient(to bottom, #243782 ,  #2c3e50)",
        minHeight: "100vh",
        width: "100%",
        paddingTop: "30px",
      }}
    >
      <ToastContainer position="bottom-right"></ToastContainer>

      <LoginHeader />

      <LanguagePicker></LanguagePicker>

      <div
        className="card shadow-sm mt-5"
        style={{
          maxWidth: "480px",
          width: "100%",
          margin: "0 auto",
        }}
      >
        <div
          className="card-body text-center"
          style={{
            boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src={stellantis}
              style={{
                maxWidth: "250px",
                height: "auto",
                marginBottom: "10px",
              }}
              alt="Stellantis"
            />
            <img
              src={kuantum}
              style={{
                maxWidth: "250px",
                height: "auto",
                marginBottom: "20px",
              }}
              alt="Kuantum"
            />
          </div>

          <div className="input-group mb-3">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faUser} />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Kullanıcı Adı"
              aria-label="Kullanıcı Adı"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="input-group mb-4">
            <span className="input-group-text">
              <FontAwesomeIcon icon={faLock} />
            </span>
            <input
              type="password"
              className="form-control"
              placeholder="Şifre"
              aria-label="Şifre"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          {loading ? (
            <div className="spinner-border text-secondary" role="status">
              <span className="visually-hidden">Yükleniyor...</span>
            </div>
          ) : (
            <button
              className="btn w-100"
              type="submit"
              onClick={handleLogin}
              style={{ backgroundColor: "#2c3e50", color: "white" }}
            >
              Oturum Aç
            </button>
          )}

          <div className="mt-2 d-flex align-items-center justify-content-center">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="flexCheckChecked"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            <label
              className="form-check-label ms-2"
              htmlFor="flexCheckChecked"
              style={{ fontSize: "14px" }}
            >
              Beni Hatırla
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
